import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M12.5 10c0-.92.746-1.666 1.667-1.666a3.333 3.333 0 0 1 0 6.667c-.92 0-1.667-.746-1.667-1.667zm-5 0c0-.92-.746-1.666-1.667-1.666a3.333 3.333 0 0 0 0 6.667c.92 0 1.667-.746 1.667-1.667z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M2.5 11.667v-2.5a7.5 7.5 0 0 1 15 0v4.039c0 1.673 0 2.51-.294 3.162a3.33 3.33 0 0 1-1.671 1.672c-.653.294-1.49.294-3.163.294H10"
    }, null, -1)
  ]))]))
}
export default { render: render }